import React from "react";
import Shake from "react-reveal/Shake";
import noMatch from "../../assets/images/noMatch.png";

function NotFound() {
  return (
    <div
      style={{
        padding: "5%",
        backgroundColor: "#004990",
        height: "100vh",
        width: "100%",
      }}
    >
      <div>
        <Shake>
          <h1 style={{ color: "#fff" }}>Error 404</h1>
        </Shake>
      </div>
      <h2 className={"col-5"} style={{ color: "#fff", marginTop: "10%" }}>
        Vaya, no pudimos encontrar lo que estabas buscando
      </h2>
      <img
        src={noMatch}
        alt="404Error"
        style={{
          heigh: "70%",
          width: "70%",
          position: "absolute",
          right: 0,
          top: 0,
        }}
      />
    </div>
  );
}

export default NotFound;
